<template>
  <v-container v-if="preaspirante">
    <v-row>
      <v-col cols="12">
        <v-btn @click="$router.go(-1)" text class="back-button">
          <v-icon>mdi-arrow-left</v-icon>
          Volver al catálogo
        </v-btn>
      </v-col>
    </v-row>
    <v-row justify="center">
      <v-col cols="5">
        <v-card class="modern-card">
          <v-card-title class="font-weight-bold justify-center card-title">Captura de voz</v-card-title>
          <v-card-text>
            <v-form v-model="capturaVozForm">
              <v-container>
                <v-row>
                  <v-col cols="12">
                    <v-text-field
                      :value="getFullName(preaspirante)"
                      rounded
                      filled
                      dense
                      class="modern-input"
                      label="Aspirante"
                      readonly
                    ></v-text-field>
                  </v-col>
                  <v-col cols="12">
                    <v-text-field
                      v-model="fecha"
                      v-mask="'##/##/####'"
                      rounded
                      filled
                      dense
                      class="modern-input"
                      :rules="dateRules"
                      hint="Formato de fecha: DD/MM/YYYY"
                    >
                      <template v-slot:label>Fecha de captura <span class="red--text">*</span> </template>
                    </v-text-field>
                  </v-col>
                  <v-col cols="12">
                    <v-file-input
                      v-model="file"
                      rounded
                      filled
                      dense
                      class="modern-input"
                      :rules="nameRules"
                      prepend-icon="mdi-microphone"
                    >
                      <template v-slot:label>Adjuntar archivo de voz <span class="red--text">*</span> </template>
                    </v-file-input>
                  </v-col>
                  <v-col cols="12">
                    <v-textarea
                      v-model="observaciones"
                      rounded
                      filled
                      dense
                      class="modern-input"
                      label="Observaciones"
                      no-resize
                      rows="4"
                    ></v-textarea>
                  </v-col>
                </v-row>
              </v-container>
            </v-form>
          </v-card-text>
          <v-card-actions class="justify-center pb-8">
            <v-btn
              class="action-button px-8"
              :disabled="!capturaVozForm || loading"
              v-on:click="triggerSaveBiometrico()"
              >Registrar</v-btn
            >
          </v-card-actions>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>
<script>
import { mapActions, mapGetters, mapMutations } from 'vuex'
import moment from 'moment'

export default {
  props: {
    id: {
      type: Number,
    },
  },

  async mounted() {
    this.SET_PREASPIRANTE_PARA_VALIDACION(this.id)
  },

  data() {
    return {
      loading: false,
      capturaVozForm: false,
      menu: false,

      observaciones: '',
      fecha: null,
      file: null,
      nombre: null,

      nameRules: [(v) => !!v || 'Este campo es requerido.'],
      dateRules: [
        (v) => !!v || 'Este campo es requerido.',
        (v) => {
          var date = moment(v, this.API_DATE_FORMAT)
          return moment(date, this.API_DATE_FORMAT).isValid() || 'El formato de fecha debe ser DD/MM/YYYY'
        },
      ],
    }
  },

  computed: {
    ...mapGetters('preaspirante', {
      preaspirante: 'getPreaspiranteParaValidacion',
    }),
  },

  methods: {
    ...mapActions('biometrico', ['saveBiometricoPersonal']),
    ...mapActions('preaspirante', ['fetchPreaspirantes']),
    ...mapMutations('preaspirante', ['SET_PREASPIRANTE_PARA_VALIDACION']),

    triggerSaveBiometrico: async function () {
      this.loading = true

      await this.saveBiometricoPersonal({
        nombre: this.file.name,
        fk_idPersonal: this.id,
        fk_idTipoBiometrico: 2,
        observaciones: this.observaciones,
        fechaRealizacion: this.fecha,
        file: this.file,
      })

      await this.fetchPreaspirantes()
      this.loading = false
      this.$router.push('/personal/preaspirantes')
    },

    saveBirthdayDate: function (date) {
      this.$refs.menu.save(date)
    },
  },
}
</script>

<style scoped>
.back-button {
  color: var(--v-secondary-base) !important;
  font-weight: 600;
}

.back-button:hover {
  background-color: rgba(var(--v-secondary-base-rgb), 0.1) !important;
}

.modern-card {
  background: rgba(26, 38, 46, 0.6) !important;
  backdrop-filter: blur(10px) !important;
  -webkit-backdrop-filter: blur(10px) !important;
  border: 1px solid rgba(var(--v-secondary-base-rgb), 0.2) !important;
  border-radius: 20px !important;
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.3) !important;
  transition: all 0.3s ease !important;
}

.card-title {
  padding: 20px 24px !important;
  background: rgba(0, 0, 0, 0.15) !important;
  border-bottom: 1px solid rgba(var(--v-secondary-base-rgb), 0.2) !important;
  font-size: 1.5rem !important;
  font-weight: 700 !important;
  color: #e0e0e0 !important;
}

::v-deep .modern-input {
  background-color: rgba(0, 0, 0, 0.3) !important;
}

::v-deep .modern-input.v-text-field--filled > .v-input__control > .v-input__slot,
::v-deep .modern-input.v-file-input > .v-input__control > .v-input__slot {
  background: rgba(0, 0, 0, 0.3) !important;
  border: 1px solid rgba(var(--v-secondary-base-rgb), 0.2) !important;
  border-radius: 12px !important;
  transition: all 0.3s ease !important;
}

::v-deep .modern-input.v-text-field--filled:hover > .v-input__control > .v-input__slot,
::v-deep .modern-input.v-file-input:hover > .v-input__control > .v-input__slot {
  border-color: rgba(var(--v-secondary-base-rgb), 0.4) !important;
  background: rgba(0, 0, 0, 0.4) !important;
}

::v-deep .modern-input.v-input--is-focused.v-text-field--filled > .v-input__control > .v-input__slot,
::v-deep .modern-input.v-input--is-focused.v-file-input > .v-input__control > .v-input__slot {
  border-color: var(--v-secondary-base) !important;
  box-shadow: 0 0 0 2px rgba(var(--v-secondary-base-rgb), 0.15) !important;
  background: rgba(0, 0, 0, 0.5) !important;
}

::v-deep .modern-input .v-text-field__slot input,
::v-deep .modern-input .v-file-input__text {
  color: #e0e0e0 !important;
}

::v-deep .modern-input .v-label {
  color: rgba(224, 224, 224, 0.7) !important;
}

::v-deep .modern-input.v-input--is-focused .v-label {
  color: var(--v-secondary-base) !important;
}

::v-deep .modern-input .v-text-field__details {
  padding-left: 16px;
}

::v-deep .modern-input .v-icon {
  color: var(--v-secondary-base) !important;
}

.action-button {
  background: linear-gradient(135deg, var(--v-secondary-base) 0%, var(--v-secondary-darken1) 100%) !important;
  color: white !important;
  font-weight: 600;
  text-transform: none;
  letter-spacing: 0.5px;
  box-shadow: 0 4px 15px rgba(var(--v-secondary-base-rgb), 0.3);
  transition: all 0.3s ease;
}

.action-button:hover {
  box-shadow: 0 6px 20px rgba(var(--v-secondary-base-rgb), 0.4);
  transform: translateY(-2px);
}

.action-button:disabled {
  background: rgba(255, 255, 255, 0.12) !important;
  color: rgba(255, 255, 255, 0.3) !important;
  box-shadow: none !important;
}
</style>
